import React, { useEffect, useContext } from 'react';
import { TriggerContext } from '../../../../../../..';
import TargetingBlockRow from '../../../TargetingBlockRow';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';
import { NumberInput } from '@m/alchemy-ui';
import { TargetingActions } from '../../../../../Actions';
import { isRuleExists, formatInputNumberNullValue } from '../../../../../../../helpers';
import { Subtitle } from '../../../../../../../StyledTriggeringModal';
import { getSingleText } from '../../../../../../../../../../common/utils';
import { TextPathPrefix } from '../../../../..';

const TargetByDeclined = () => {
  const { triggerState, triggerDispatch, isReadOnly, hasErrors , setHasErrors } = useContext(TriggerContext);
  const defaultValue = getNestedProperty(triggerState, 'trigger.rules.MobileDontInviteOnDeclined.params.days');
  const [value, setValue] = React.useState(defaultValue || 1);

  useEffect(() => {
    isRuleExists(triggerState, 'trigger.rules.MobileDontInviteOnDeclined.id') ?
      triggerDispatch({ type: TargetingActions.SET_MOBILE_DONT_INVITE_BY_DECLINED_IS_ACTIVE , payload : true }) :
      triggerDispatch({ type: TargetingActions.INIT_MOBILE_DONT_INVITE_BY_DECLINED , payload : {} } );
  },[]);

  const onNumberChanged = (val) => {
    setValue(val);
    triggerDispatch({ type: TargetingActions.SET_MOBILE_DONT_INVITE_BY_DECLINED_DAYS , payload : val });
    !val ? setHasErrors({ ...hasErrors, MobileDontInviteOnDeclined: 'MobileDontInviteOnDeclined' }) : hasErrors && delete hasErrors.MobileDontInviteOnDeclined;
  };

  const handleCheckboxChange = (e) => {
    triggerDispatch({ type: TargetingActions.SET_MOBILE_DONT_INVITE_BY_DECLINED_IS_ACTIVE , payload : e.target.checked } );
    onNumberChanged(1);
  };

  return (
    <TargetingBlockRow
      checkboxLabel="Exclude users who have declined a survey invitation in the past"
      isFullWidth
      isQuarantineRule
      checked={getNestedProperty(triggerState , 'trigger.rules.MobileDontInviteOnDeclined.isActive')}
      disabled={isReadOnly}
      errorMessage={getSingleText(`${TextPathPrefix}.errors.insertValue`)}
      hasError={hasErrors && Object.keys(hasErrors).includes('MobileDontInviteOnDeclined') }
      onCheckboxChange={handleCheckboxChange}>
      <NumberInput
        min="1"
        formatValue={formatInputNumberNullValue}
        value={value}
        onNumberChange={onNumberChanged} />
      <Subtitle marginLeft={1.5}>{getSingleText(`${TextPathPrefix}.rulesTexts.days`)}</Subtitle>
    </TargetingBlockRow>
  );
};

export default TargetByDeclined;
